/**
 * Modulo Config
 * @module abstracts/config
 * @namespace Abstracts/Config
 */
import Backbone from 'backbone'
import resolveDomain from '../../../libs/resolve-domain'

/**
 * Classe Config
 *
 * @name Config
 * @extends Backbone/Model
 * @see {@link https://backbonejs.org/#Model}
 * @memberof abstracts/config
 */
class Config extends Backbone.Model {
    /**
     * Inicializados manual da Classe Config
     *
     */
    init () {
        this.set('domain', resolveDomain())
        
        // eslint-disable-next-line no-undef
        this.set('stage', CONSTANTS.stage)
        
        // eslint-disable-next-line no-undef
        this.set('hash', CONSTANTS.hash)
        
        // eslint-disable-next-line no-undef
        this.set('coreName', CONSTANTS.coreName)
    }

    /**
     * Parseia um array ou objeto para salvar a configuração
     *
     * @param {object|array} config - Array ou objeto de configuração
     * @return {void}
     */
    parse (config) {
        for (const name of Object.keys(config)) {
            if (typeof config[name] === 'object' && !Array.isArray(config[name])) {
                let newConfig = new Config()
                newConfig.parse(config[name])
                this.set(name, newConfig)
            }

            if (typeof config[name] === 'string' || Array.isArray(config[name])) {
                this.set(name, config[name])
            }
        }
    }

    /**
     * Sobrescreve o método toJSON da classe pai Backbone.Model
     *
     * @see {@link https://backbonejs.org/#Model}
     * @return {Object}
     */
    toJSON () {
        const config = super.toJSON()
        // const JSON = {};
        for (const name of Object.keys(config)) {
            if (typeof config[name].constructor && config[name].constructor.name === 'Config') {
                config[name] = config[name].toJSON()
            }
        }

        return config
    }
}

window.GPAbstractModules = window.GPAbstractModules || {}
window.GPAbstractModules.Config = Config
